import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import FaberBasicTab from 'common/FaberComponents/basic-components/FaberTab'
import NormalText from 'common/Typography/NormalText'
import ExternalFinanceV2OneUser from 'pages/Customers/sharedComponents/ExternalFinanceV2OneUser'
import {
  GetAllGlobalUsersDetails,
  TransformedFaberUserData
} from 'types/api/faber/globalCustomers.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'

import ExternalEventLogsPage from './components/ExternalEventLogsPage'
import ExternalUserProfile from './components/ExternalUserProfile'

function ExternalUserViewProfilePage() {
  const location = useLocation()

  const rowInformation = location.state as
    | GetAllFaberUsersDetails
    | GetAllGlobalUsersDetails

  const transformedRowInformation = useMemo(() => {
    if ('email' in rowInformation && 'msisdn' in rowInformation) {
      return {
        firstName: rowInformation.firstName,
        lastName: rowInformation.lastName,
        userID: rowInformation._id,
        userEmail: rowInformation.email,
        iccid: '',
        planStatus: rowInformation.status,
        planName: '',
        msisdn: rowInformation.msisdn,
        subscription: rowInformation.subscription,
        otpack: rowInformation.otpack,
        countryCode: '+65'
      } as TransformedFaberUserData
    } else if (
      'given_name' in rowInformation &&
      'family_name' in rowInformation
    ) {
      return {
        firstName: rowInformation.given_name,
        lastName: rowInformation.family_name,
        fullName: rowInformation.name,
        userID: rowInformation.user_id,
        userEmail: rowInformation.user_metadata?.email,
        iccid: '',
        planStatus: '',
        msisdn: rowInformation.user_metadata?.phone_number,
        countryCode: rowInformation.user_metadata?.country_code
      } as TransformedFaberUserData
    }
  }, [rowInformation])

  const externalUserTabs = useMemo(() => {
    return [
      {
        tabTitle: 'Overview',
        tabContent: transformedRowInformation ? (
          // The overiew page for external users
          <ExternalUserProfile customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'overview',
        passedData: rowInformation
      },
      {
        tabTitle: 'Finance',
        tabContent: transformedRowInformation ? (
          // The finance page for external users
          <ExternalFinanceV2OneUser customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'finance',
        passedData: rowInformation
      },
      {
        tabTitle: 'Event Logs',
        tabContent: transformedRowInformation ? (
          // The events log page for external users
          <ExternalEventLogsPage customerRow={transformedRowInformation} />
        ) : null,
        tabCategory: 'logs',
        passedData: rowInformation
      }
    ]
  }, [rowInformation])


  return (
    <>
      <NormalText theme='dark' variant='h5' isBold>
        Customer Details
      </NormalText>

      {/* Overview + Finance tab */}
      <FaberBasicTab tabInfo={externalUserTabs}/>

    </>
  )
}

export default ExternalUserViewProfilePage
